import React from "react";
import { TimelineLite } from "gsap";
import "./index.scss";
import progress from "utils/progress";
import { daDian } from "utils";
import Button from "../../MoreAndCancelButton";

class Slide extends React.Component {
  state = {
    showVideo: true,
  };

  textRef = null;

  videoDivRef = null;

  videoRef = null;

  slideRef = null;

  toggleVideo = () => {
    // 打点
    const { index } = this.props;
    // '公开透明',
    // '数据最小化',
    // '目的限制',
    // '安全保障',
    // '合规审查',
    // '责任明确',
    // const funcs = [
    //   daDian.moreControl,
    //   daDian.moreScreen,
    //   daDian.moreGoal,
    //   daDian.moreProtect,
    //   daDian.moreExamine,
    //   daDian.moreRespon,
    // ];
    // funcs[index]();

    this.setState((state) => {
      if (state.showVideo) {
        this.videoRef.pause();
        this.videoRef.currentTime = 0;
      } else {
        this.videoRef.play();
      }
      return { showVideo: !state.showVideo };
    });
  };

  render() {
    const { videoUrl, title, squareText, intro, index } = this.props;
    const { showVideo } = this.state;
    return (
      <div
        className="Slide"
        ref={(el) => {
          this.slideRef = el;
        }}
      >
        <div className="Slide__left">
          <div>
            <div
              className="Slide__summary"
              ref={(el) => {
                this.textRef = el;
              }}
            >
              <p className={`c${index}`}>{title}</p>
              <p>{intro}</p>
            </div>

            <div>
              <Button
                className="Slide__button"
                onClick={this.toggleVideo}
                status={showVideo ? "" : "cancel"}
                index={index}
              />
            </div>
          </div>
        </div>
        <div
          className="Slide__right"
          ref={(el) => {
            this.videoDivRef = el;
          }}
        >
          <div className="card1">
            <button
              onClick={() => {
                this.toggleVideo();
              }}
            />
            <div>
              {squareText.map((t, index) => (
                <p key={index}>{t}</p>
              ))}
            </div>
          </div>
          <div className={`card2 ${showVideo ? "" : "transparent"}`}>
            <video
              loop
              muted="muted"
              src={videoUrl}
              preload="auto"
              ref={(el) => {
                this.videoRef = el;
              }}
              onClick={() => {
                showVideo && this.toggleVideo();
              }}
              onCanPlayThrough={() => {
                console.log(
                  "onCanPlayThrough",
                  videoUrl,
                  this.videoRef.readyState,
                  this.videoRef.seekable.start(0),
                  this.videoRef.seekable.end(0)
                );
                progress(videoUrl);
              }}
              onProgress={() => {
                if (this.videoRef.buffered.length > 0) {
                  console.log(
                    "onProgress -->",
                    videoUrl,
                    this.videoRef.buffered.end(0),
                    this.videoRef.seekable.end(0)
                  );
                  progress(
                    videoUrl,
                    this.videoRef.seekable.end(0),
                    this.videoRef.buffered.end(0)
                  );
                }
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    const {
      beginSlidesWheelCallbackEnhanced,
      beginSlidesWheelCallbackEnhancedFromBack,
      index,
      prevSlideAnimationReversedCallback,
      indicateAnimationComplete,
    } = this.props;

    this.bottomToMidTl = new TimelineLite({
      paused: true,
      onComplete:
        index === 0
          ? () => {
              this.topToMidTl.progress(1, true).pause();
              beginSlidesWheelCallbackEnhanced();

              this.state.showVideo && this.videoRef.play();
            }
          : () => {
              this.topToMidTl.progress(1).pause();
              indicateAnimationComplete();

              this.state.showVideo && this.videoRef.play();
            },
      onReverseComplete: prevSlideAnimationReversedCallback,
    });
    this.bottomToMidTl
      .fromTo(this.textRef, 0.6, { y: "6rem" }, { y: 0 })
      .fromTo(this.slideRef, 0.6, { autoAlpha: 0 }, { autoAlpha: 1 }, "-=0.6")
      .fromTo(this.videoDivRef, 0.6, { scale: 0.8 }, { scale: 1 }, "-=0.6");

    this.topToMidTl = new TimelineLite({
      paused: true,
      onComplete:
        index === 4
          ? () => {
              this.bottomToMidTl.progress(1, true).pause();
              beginSlidesWheelCallbackEnhancedFromBack();

              this.state.showVideo && this.videoRef.play();
            }
          : () => {
              this.bottomToMidTl.progress(1, true).pause();
              indicateAnimationComplete();

              this.state.showVideo && this.videoRef.play();
            },
      onReverseComplete: prevSlideAnimationReversedCallback,
    });
    this.topToMidTl
      .fromTo(this.textRef, 0.6, { y: "-6rem" }, { y: 0 })
      .fromTo(this.slideRef, 0.6, { autoAlpha: 0 }, { autoAlpha: 1 }, "-=0.6")
      .fromTo(this.videoDivRef, 0.6, { scale: 0.8 }, { scale: 1 }, "-=0.6");
  }
}

export default Slide;
